/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * PolicyType
 */
export enum PolicyType {
  MEDICARE = 'MEDICARE',
  IFP = 'IFP',
  MEDICARE_IFP = 'MEDICARE_IFP',
}
